import { ArrowRightIcon } from '@heroicons/react/solid';
import clsx from 'clsx';
import Image, { StaticImageData } from 'next/image';
import Link from 'next/link';
import React from 'react';

import ButtonDefault, { ButtonVariants } from '../basic/button';
import { ShouldRender } from '../basic/ShouldRender';
import { LiveEmptyScreen } from '../../../../assets';

interface Props {
  heading?: string;
  desc?: string;
  link?: string;
  icon?: string | StaticImageData;
  iconSize?: { width?: number; height?: number };
}

const EmptyState: React.FC<Props> = ({
  link,
  heading = 'No Streaming right now',
  desc = 'Explore our Schools, short books. Grab a snack and binge-learn till it wakes up.',
  icon = LiveEmptyScreen,
  iconSize,
}) => {
  return (
    <div>
      <div className='flex justify-center pt-10 pb-20 md:pt-20 '>
        <span
          className={clsx(
            iconSize?.width ? 'gap-y-1' : 'gap-y-4',
            'flex flex-col justify-center text-white ',
          )}
        >
          <div className='flex justify-center'>
            <Image
              alt='LiveEmptyScreen'
              src={icon}
              width={iconSize?.width ?? 200}
              height={iconSize?.height ?? 170}
            />
          </div>
          <p
            className={clsx(
              iconSize?.width ? 'gap-y-1' : 'gap-y-4',
              'font-semibold text-center',
            )}
          >
            {heading}
          </p>
          <span className='flex justify-center'>
            <p className='flex justify-center text-center text-textDarkGrayColor w-2/3'>
              {desc}
            </p>
          </span>
          <ShouldRender check={link}>
            <div className='flex justify-center'>
              <Link href={link ?? '/product'}>
                <ButtonDefault
                  variant={ButtonVariants.UNSTYLED}
                  size={4}
                  className='bg-[#212121] whitespace-nowrap flex justify-center items-center gap-x-2 text-white text-sm font-medium px-5 py-2 rounded-lg'
                >
                  Explore More
                  <ArrowRightIcon className='ml-2 w-4 h-4' />
                </ButtonDefault>
              </Link>
            </div>
          </ShouldRender>
        </span>
      </div>
    </div>
  );
};

export default EmptyState;
